import { Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LogEventCamera from '../../components/LogEventCamera';

export const HistoryEventsModal = ({
  title,
  isModalVisible,
  handleOk,
  handleCancel,
  data,
  variantPage = '',
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('History event') + ` (${title}` ?? ''}
      className="modal-event-camera"
      style={{ top: 64 }}
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="85%"
      footer={false}
    >
      <LogEventCamera dataDevice={data} variantPage={variantPage} />
    </Modal>
  );
};

export default HistoryEventsModal;
